import { useCallback, useEffect, useRef, useState } from 'react'

import { useResetEditingState } from '@/atoms'
import { updateExecutionEvents } from '@/features/domain/order'
import { useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'

export const useOnUpdateExecutionEvents = () => {
  const dispatch = useAppDispatch()

  const stopEditing = useResetEditingState()

  const mounted = useRef<boolean>(false)
  const [submitting, setSubmitting] = useState<boolean>(false)
  const toast = useNotification()

  const onUpdateExecutionEvents = useCallback(
    async (updateRequest: uui.domain.ui.forms.ExecutionEventsChanges) => {
      try {
        setSubmitting(true)

        const thunkResult = await dispatch(updateExecutionEvents(updateRequest))

        if (mounted.current) {
          setSubmitting(false)
        }

        if (!updateExecutionEvents.fulfilled.match(thunkResult)) {
          throw new Error(thunkResult.payload?.message ?? 'Internal error')
        }

        stopEditing()
      } catch (e) {
        toast.error(e.message)
      }
    },
    [dispatch, stopEditing, toast],
  )

  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
    }
  }, [])

  return {
    submitting,
    onUpdateExecutionEvents,
  }
}
